import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Lang Lang – McDonalds Track</h3>
      </div>
      <div className="popup-content-source">
        <p>
          <span className="bold">
          We’re planning to upgrade the water main along McDonalds Track and Westernport Road in Lang Lang. 
          </span>
        </p>
        <p>
        We’ve awarded the construction of the water main renewal to our industry partner Abergeldie, KBR, BMD Joint Venture (ABK). 
        We expect construction to begin in October 2026 for approximately 6 months(dependant on weather and ground conditions). 
        </p>
        <p>
          For more information visit{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/planned-works/mcdonalds-track/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Water Renewals (blue)`,
                action: '<a href> link',
                label: 'MORE INFO: McDonalds Track and Westernport Road',
              });
            }}
          >
            McDonalds Track and Westernport Road
            | South East Water
          </a>{' '}
          email{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Water Renewals (blue)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: McDonalds Track and Westernport Road',
              });
            }}
          >
            engagement@sew.com.au
          </a>{' '}
          or call <a href="tel:1800403777">1800 403 777</a> |{' '}
        </p>
      </div>
    </>
  );
};

export default Content;
